import type { ReactNode } from 'react';

type GoldWordProps = {
  children: ReactNode;
};

export function GoldWord({ children }: GoldWordProps) {
  return <span className="text-[color:var(--color-accent)]">{children}</span>;
}
